<section class="conta-pagar-shell">
  <header class="conta-pagar-hero">
    <div>
      <h2 class="conta-pagar-title">{{ isEditMode ? 'Editar Conta a Pagar' : 'Nova Conta a Pagar' }}</h2>
      <p class="conta-pagar-subtitle">Gerencie seus compromissos financeiros.</p>
    </div>
    <span class="conta-pagar-chip">{{ isEditMode ? 'Edição' : 'Cadastro' }}</span>
  </header>

  <form (ngSubmit)="save()" id="contaPagarForm" class="conta-pagar-card">
    <div *ngIf="isEdicaoBloqueada" class="alert alert-info" role="alert">
      Este registro está com status {{ conta.status }} e está bloqueado para edição. Apenas contas com status AGUARDANDO podem ser editadas.
    </div>

    <fieldset [disabled]="isEdicaoBloqueada">
      <div class="form-section">
        <h3>Dados da Conta</h3>
        <div class="row g-3">
          <div class="col-md-6">
            <label for="fornecedor" class="form-label">Fornecedor</label>
            <select id="fornecedor" class="form-control" [(ngModel)]="conta.fornecedor.id" name="fornecedor" required>
              <option *ngFor="let f of fornecedores" [value]="f.id">{{ f.razaoSocial }}</option>
            </select>
          </div>
          <div class="col-md-6">
            <label for="descricao" class="form-label">Descrição</label>
            <input type="text" class="form-control" id="descricao" [(ngModel)]="conta.descricao" name="descricao" required>
          </div>
          <div class="col-md-6">
            <label for="valor_a_pagar" class="form-label">{{ isParcelada ? 'Valor de Cada Parcela' : 'Valor a Pagar' }}</label>
            <input
              type="text"
              class="form-control"
              id="valor_a_pagar"
              [value]="valorAPagarDisplay"
              (input)="onValorAPagarInput($event)"
              (blur)="formatValorAPagarDisplay()"
              name="valor_a_pagar"
              [required]="true">
            <small *ngIf="isParcelada" class="field-helper">Informe quanto vale cada parcela, não o total da compra.</small>
          </div>
          <div class="col-md-6">
            <label for="valor_final" class="form-label">Valor Final</label>
            <input type="number"
              class="form-control"
              id="valor_final"
              [(ngModel)]="conta.valor_final"
              name="valor_final"
              readonly
              [style.pointer-events]="isReadOnly ? 'none' : 'auto'"
              [style.background-color]="isReadOnly ? '#e9ecef' : '#fff'">
          </div>
          <div class="col-md-6" *ngIf="!isParcelada">
            <label for="dataVencimento" class="form-label">Data de Vencimento</label>
            <input type="date" class="form-control" id="dataVencimento" [(ngModel)]="conta.dataVencimento" name="dataVencimento" required>
            <small class="field-helper">A data inicial vem preenchida automaticamente com a data de hoje.</small>
          </div>
          <div class="col-md-6">
            <label for="dataPagamento" class="form-label">Data de Pagamento</label>
            <input type="date" class="form-control" id="dataPagamento" [(ngModel)]="conta.dataPagamento" name="dataPagamento" readonly
              [style.pointer-events]="isReadOnly ? 'none' : 'auto'"
              [style.background-color]="isReadOnly ? '#e9ecef' : '#fff'">
          </div>
          <div class="col-md-6">
            <label for="status" class="form-label">Status</label>
            <select id="status" class="form-control" [(ngModel)]="conta.status" name="status" required>
              <option value="AGUARDANDO">AGUARDANDO</option>
              <option value="CANCELADO">CANCELADO</option>
            </select>
          </div>
          <div class="col-md-6">
            <label for="destino" class="form-label">Destino</label>
            <input type="text" class="form-control" id="destino" [(ngModel)]="conta.destino" name="destino">
          </div>
        </div>
      </div>

      <div class="form-section">
        <h3>Classificação</h3>
        <div class="row g-3">
          <div class="col-md-6">
            <label for="grupo" class="form-label">Grupo de Despesa</label>
            <select id="grupo" class="form-control dropdown-enhanced" [(ngModel)]="conta.grupo.id" (ngModelChange)="onGrupoChange()" name="grupo" required>
              <option [ngValue]="0">Selecione um grupo</option>
              <option *ngFor="let g of grupos" [ngValue]="g.id">{{ g.nome }}</option>
            </select>
          </div>
          <div class="col-md-6">
            <label for="subgrupo" class="form-label">Subgrupo de Despesa</label>
            <select id="subgrupo" class="form-control dropdown-enhanced" [(ngModel)]="conta.subgrupo.id" name="subgrupo" [disabled]="!conta.grupo.id" required>
              <option [ngValue]="0">{{ conta.grupo.id ? 'Selecione um subgrupo' : 'Escolha primeiro o grupo' }}</option>
              <option *ngFor="let s of filteredSubgrupos" [ngValue]="s.id">{{ s.nome }}</option>
            </select>
            <small class="field-helper">Subgrupos são exibidos conforme o grupo selecionado.</small>
          </div>
          <div class="col-md-12">
            <label for="observacao" class="form-label">Observação</label>
            <textarea class="form-control" id="observacao" [(ngModel)]="conta.observacao" name="observacao" rows="3"></textarea>
          </div>
        </div>
      </div>

      <div class="form-section" *ngIf="!isEditMode">
        <div class="parcelamento-toggle">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="isParcelada"
              [(ngModel)]="isParcelada" (ngModelChange)="invalidarPrevia()" name="isParcelada">
            <label class="form-check-label" for="isParcelada">Conta parcelada</label>
          </div>
          <small class="field-helper">Gera automaticamente todas as parcelas em um único lançamento.</small>
        </div>

        <div *ngIf="isParcelada" class="parcelamento-body">
          <h3>Parcelamento</h3>
          <div class="row g-3">
            <div class="col-md-4">
              <label for="quantidadeParcelas" class="form-label">Quantidade de Parcelas</label>
              <input type="number" class="form-control" id="quantidadeParcelas" min="2" max="60"
                [(ngModel)]="quantidadeParcelas" (ngModelChange)="invalidarPrevia()" name="quantidadeParcelas">
              <small class="field-helper">De 2 a 60 parcelas.</small>
            </div>
            <div class="col-md-4">
              <label for="periodicidade" class="form-label">Periodicidade</label>
              <select id="periodicidade" class="form-control dropdown-enhanced"
                [(ngModel)]="periodicidade" (ngModelChange)="invalidarPrevia()" name="periodicidade">
                <option *ngFor="let p of periodicidades" [ngValue]="p.valor">{{ p.rotulo }}</option>
              </select>
            </div>
            <div class="col-md-4">
              <label for="dataPrimeiroVencimento" class="form-label">1º Vencimento</label>
              <input type="date" class="form-control" id="dataPrimeiroVencimento"
                [(ngModel)]="dataPrimeiroVencimento" (ngModelChange)="invalidarPrevia()" name="dataPrimeiroVencimento">
              <small class="field-helper">Vencimento em fim de semana é postergado para a segunda-feira.</small>
            </div>

            <div class="col-md-12">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="possuiEntrada"
                  [(ngModel)]="possuiEntrada" (ngModelChange)="invalidarPrevia()" name="possuiEntrada">
                <label class="form-check-label" for="possuiEntrada">Tem entrada</label>
              </div>
              <small class="field-helper">A entrada é a 1ª parcela — não uma parcela a mais.</small>
            </div>

            <div class="col-md-6" *ngIf="possuiEntrada">
              <label for="valorEntrada" class="form-label">Valor da Entrada</label>
              <input type="text" class="form-control" id="valorEntrada" name="valorEntrada"
                [value]="valorEntradaDisplay"
                (input)="onValorEntradaInput($event)"
                (blur)="formatValorEntradaDisplay()">
            </div>
            <div class="col-md-6" *ngIf="possuiEntrada">
              <label for="dataEntrada" class="form-label">Vencimento da Entrada</label>
              <input type="date" class="form-control" id="dataEntrada"
                [(ngModel)]="dataEntrada" (ngModelChange)="invalidarPrevia()" name="dataEntrada">
            </div>

            <div class="col-md-12">
              <button type="button" class="btn btn-outline-primary" (click)="gerarPrevia()" [disabled]="isGerandoPrevia">
                {{ isGerandoPrevia ? 'Gerando...' : 'Gerar prévia' }}
              </button>
            </div>
          </div>

          <div *ngIf="previa" class="previa-parcelas">
            <div class="table-responsive">
              <table class="table table-sm table-striped align-middle">
                <thead>
                  <tr>
                    <th scope="col">Parcela</th>
                    <th scope="col">Vencimento</th>
                    <th scope="col" class="text-end">Valor</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let parcela of previa.parcelas">
                    <td>
                      {{ parcela.numParcela }}/{{ parcela.totalParcelas }}
                      <span *ngIf="parcela.entrada" class="badge bg-info text-dark ms-1">entrada</span>
                    </td>
                    <td>
                      {{ parcela.dataVencimento | date:'dd/MM/yyyy' }}
                      <span *ngIf="parcela.vencimentoAjustado" class="badge bg-warning text-dark ms-1"
                        title="Vencimento postergado para o próximo dia útil">ajustado</span>
                    </td>
                    <td class="text-end">{{ parcela.valor | currency:'BRL' }}</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <th scope="row" colspan="2">Total ({{ previa.quantidadeParcelas }} parcelas)</th>
                    <th class="text-end">{{ previa.valorTotal | currency:'BRL' }}</th>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
    </fieldset>
  </form>

  <footer class="action-bar">
    <button type="button" class="btn btn-outline-secondary" (click)="cancel()">Cancelar</button>
    <button *ngIf="!isEdicaoBloqueada" type="submit" form="contaPagarForm" class="btn btn-primary"
      [disabled]="isParcelada && !previa"
      [title]="isParcelada && !previa ? 'Gere a prévia das parcelas antes de salvar' : ''">
      {{ isParcelada ? 'Gerar Parcelas' : 'Salvar' }}
    </button>
  </footer>
</section>
